import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-x-2 items-center text-nowrap" }
const _hoisted_2 = { class: "text-xs font-normal" }

import { computed } from 'vue';
	import filters from '@/core/filters';
	import { useSettings } from '@/store/store';
	import { useUserName } from '@/composables/useUserName';
	import { useRooms } from '@/store/rooms';
	import { useUserColor } from '@/composables/useUserColor';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'UserDisplayName',
  props: {
		user: {
			type: String,
			required: true,
		},
	},
  setup(__props) {

	const { getUserDisplayName } = useUserName();
	const { color, textColor } = useUserColor();
	const rooms = useRooms();
	const settings = useSettings();

	const props = __props;

	const displayName = computed(() => {
		const currentRoom = rooms.currentRoom;
		return getUserDisplayName(props.user, currentRoom);
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(`${_unref(textColor)(_unref(color)(__props.user))} font-semibold text-sm`)
    }, _toDisplayString(_unref(filters).maxLengthText(displayName.value, _unref(settings).getDisplayNameMaxLength)), 3),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(filters).extractPseudonym(__props.user)), 1)
  ]))
}
}

})